import { CognitoConfiguration } from '@cognitoforms/utils/clientside-configuration';
import { getThumbprint } from '@cognitoforms/api/services/authentication';

export default function generateAuthorizeUrl(
	action: AuthenticationAction,
	context: AuthenticationContext,
	options?: LoginOptions | SignupOptions | ValidateOptions | InviteOptions
) {
	let redirectUrl = CognitoConfiguration.OpenIdConnectAuthorizeEndpoint +
		`${action.toString()}` +
		`?context=${context.toString()}` +
		`&thumbprint=${getThumbprint()}`;

	if (options) {
		if (options.returnUrl)
			options.returnUrl = encodeURIComponent(options.returnUrl);

		for (const [key, value] of Object.entries(options)) {
			if (value)
				redirectUrl = redirectUrl + `&${key}=${value}`;
		}
	}

	return redirectUrl;
}

export type AuthenticationProvider = 'Google' | 'Facebook' | 'Microsoft';

export type AuthenticationAction = 'login' | 'signup' | 'validate';

export type AuthenticationContext = 'redirect' | 'popup';

export type AuthenticationMethodType = 'Unknown' | 'Email' | 'Google' | 'Facebook' | 'Microsoft' | 'Support' | 'Custom';

type LoginOptions = {
	returnUrl: string;
	inviteCode: string;
	authMethodType: AuthenticationMethodType;
	requiredOrg: string;
	requiredOrgName: string;
	destinationOrgName: string;
	requiredUser: string;
	logoutReason: string;
}

type SignupOptions = {
	returnUrl: string;
	inviteCode: string;
	authMethodType: AuthenticationMethodType;
	organizationName: string;
	timezone: string;
}

type ValidateOptions = {
	AuthenticationType: AuthenticationMethodType;
	AuthenticationProvider: AuthenticationProvider;
	TenantId: string;
	ClientId: string;
	ClientSecret: string;
}

type InviteOptions = {
	encryptedUserInfo: string;
	encryptedState: string;
}